<template>
  <article class="accessIndex">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg10>
            <p class="table_card__head--title">
              {{!hasAlreadyFilter?'Usuarios en la locación actualmente':'Usuarios en la locación '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}}
            </p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  v-if="getUserType() !== 'Counter'"
                  @click="$router.push({name: 'access'})"
                  class="breadcums__option"
                >
                  Resumen
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'location_access', params: {id: location_id}})"
                  class="breadcums__option"
                >
                  {{ location_name }}
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Usuarios
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg1 class="filter_options">
            <button
            class="faccess_button"
            v-if="accesses.length > 0"
            @click="makeExcelReport()">Generar reporte
          </button>
          </v-flex>
          <v-flex lg1 class="filter_options">
            <div
              class="buttom_reload"
              @click="pagination_query=false;filterUsers(true);date_available=false;"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <app-date-picker
          v-if="date_available"
          @filterQuery="pagination_query=false;filterUsersByButton($event)"
        >
        </app-date-picker>
      </div>
      <v-data-table
      :headers="headers"
      :items="accesses"
      :pagination.sync="sorter"
      hide-actions
      class="elevation-1">
      <template
        slot="items"
        slot-scope="props">
        <td>{{ props.item.user }}</td>
        <td>{{ props.item.user_rut }}</td>
        <td>{{ dateFormatText($moment(props.item.in_date).format(" MM/DD/YYYY - h:mm a")) }}</td>
        <td>{{ props.item.out_date != '' ? dateFormatText($moment(props.item.out_date).format(" MM/DD/YYYY - h:mm a")) : '' }}</td>
        <!-- <td>{{ props.item.direction }}</td> -->
        <!-- <td>{{ props.item.site }}</td> -->
      </template>
    </v-data-table>
    <div
      class="table_card__footer"
      v-if="accesses.length>0&& pages > 1"
    >
      <v-pagination
        color="#1476FB"
        v-model="pagination.page"
        :length="pages"
      >
      </v-pagination>
      <label
        class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label
        class="accessIndex__pagination--current_text"
        v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
        {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
      </label>
      <label
        class="accessIndex__pagination--current_text"
        v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      sorter: {sortBy: 'in_date', descending: true, rowsPerPage: -1},
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      datePickerFirstClick:false,
      hasAlreadyFilter:false,
      filterSearchedDate:new Date().toISOString().substr(0, 10),
      filterSearchedDate2:new Date().toISOString().substr(0, 10),
      initialRender:true,
      pages:2,
      months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
      pagination: {page:1,rowsPerPage:24},
      accesses: [],
      headers: [
        {text:'Usuario', value: 'user'},
        {text:'RUT', value: 'user_rut'},
        {text:'Fecha y hora de ingreso', value: 'in_date'},
        {text:'Fecha y hora de salida', value: 'out_date'}
      ],
      titlelocation:'',
      months_text:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
      location_id: '',
      location_name: ''
    }
  },
  watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterUsers(false);

       }

       }
    }
    ,
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    dateFormat(datex){
      var sections=datex.split("-");
      var index=Number(sections[1])-1;
      sections[1]=this.months[index];
      datex=sections.join("/");
      return datex;
    },
    dateFormatText(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months_text[index];
        datex=sections.join(" ");
        return datex;
    },
    filterUsersByButton(dates){
      var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' }
      this.date =this.modifyDateFormatToStatus(object.date_from);
      this.date2 =this.modifyDateFormatToStatus(object.date_to);
      if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
        this.datePickerFirstClick=true;
      }
      // alert(this.datePickerFirstClick+this.date+this.date2);
      if(this.datePickerFirstClick){
        this.hasAlreadyFilter=true;
        this.filterSearchedDate=this.date;
        this.filterSearchedDate2=this.date2;
        this.filterUsers(false);
      }

    },
    filterUsers(defaultOption){
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;
      //alert(this.$route.params.date+" "+this.$route.params.date2+" "+this.$route.params.filter);
      // var initialDate=new Date().toISOString().substr(0, 10);
      // var lastDate=new Date().toISOString().substr(0, 10);
      var initialDate= ""
      var lastDate=""
      if(!defaultOption){
        initialDate=this.date;
        lastDate=this.date2;
         // initialDate=this.date;
         // lastDate=this.date2;
      }
      else if(this.initialRender&&this.$route.params.filter){
        this.initialRender=false;
        initialDate=this.$route.params.date;
        lastDate=this.$route.params.date2;
        this.date=this.$route.params.date;
        this.date2=this.$route.params.date2;
        this.filterSearchedDate=this.$route.params.date;
        this.filterSearchedDate2=this.$route.params.date2;
        this.datePickerFirstClick=true;
        this.hasAlreadyFilter=true;
        this.saved_default_option=false;
      }
      else{
        this.date= new Date().toISOString().substr(0, 10);
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
        this.hasAlreadyFilter=false;
      }
      try {
        this.$http.get('access/in_out_activity',{
          params:{
            location_id: this.$route.params.id,
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page,
            current:!this.hasAlreadyFilter,
            location_name : this.location_name
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          console.log('index_location ', response)
          this.accesses=[];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // this.accesses = response.body.data;
          var vm =this;
          var temp = response.body.data;

          if(response.body.device){
            
            console.log('llega esto', response.body.data)
            // var dataAccess = temp.data.AcsEvent.InfoList
            var dataAccess = temp.data

            for(var user in dataAccess){

              var validate = true

              console.log('time', dataAccess[user]["time"])

              for (var i = 0; i < vm.accesses.length; i++) {

                if(vm.accesses[i].user_rut == dataAccess[user]["employeeNoString"] && vm.accesses[i].out_date == "" ){
                  validate = false
                  vm.accesses[i].out_date = dataAccess[user]["time"]
                }
              }

              if( validate == true){

                  vm.accesses.push({
                        user: dataAccess[user]["name"],
                        user_rut: dataAccess[user]["employeeNoString"],
                        in_date: dataAccess[user]["time"],
                        out_date: ""
    
                  })
              }

            }

          // this.invitations_size=vm.accesses.length;
          // this.pages= Math.floor(vm.accesses.length/12); 

          }else{

          // str.substring(0, str.length-1) + "-" + str.substring(str.length-1)
            for(var user in temp){
                var rut='';
                var name=''

                if(temp[user]["user_rut"]!=null){
                  rut = rut.substring(0, rut.length-1) + "-" + rut.substring(rut.length-1);
                }

                if(temp[user]["invited_client"]){
                    var rut = temp[user]["invited_client"]["rut"];
                    var name = temp[user]["invited_client"]["name"];
                  }else{
                    var rut = temp[user]["user_rut"];
                    var name = temp[user]["user_name"];
                  }


                  vm.accesses.push({
                    user:name,
                    user_rut:rut,
                    // in_date:this.dateFormatText(this.$moment(temp[user]["date_in"]).format(" MM/DD/YYYY - h:mm a")),
                    in_date:temp[user]["date_in"],

                    // in_date:vm.$moment(temp[user]["date_in"]).format("dddd, MMMM Do YYYY, h:mm:ss a"),
                    out_date: temp[user]["date_out"] != undefined ?
                        // this.dateFormatText(this.$moment(temp[user]["date_out"]).format(" MM/DD/YYYY - h:mm a")) : ""
                        temp[user]["date_out"] : ""

                  })
            }

            

          }

          this.invitations_size=response.body.total_elements;
            this.pages=response.body.pages;
          
          // console.table('vm.accesses',vm.accesses);
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    makeExcelReport() {
      console.log('makeExcelReport')
      let accessData = [];
      let defaultOption = this.saved_default_option;
      //alert(this.$route.params.date+" "+this.$route.params.date2+" "+this.$route.params.filter);
      // var initialDate=new Date().toISOString().substr(0, 10);
      // var lastDate=new Date().toISOString().substr(0, 10);
      var initialDate = ""
      var lastDate = ""
      if (!defaultOption) {
        initialDate = this.date;
        lastDate = this.date2;
      }
      else if (this.initialRender && this.$route.params.filter) {
        initialDate = this.$route.params.date;
        lastDate = this.$route.params.date2;
      }
      this.$http.get('access/in_out_activity', {
        params: {
          location_id: this.$route.params.id,
          offset_time: new Date().getTimezoneOffset(),
          first_date: initialDate,
          last_date: lastDate,
          current: !this.hasAlreadyFilter,
          location_name : this.location_name
        },
        headers:
        {
          "X-Device-ID": this.getDeviceId(),
          "Authorization": 'Bearer ' + this.getUserToken()
        }
      }
      ).then(function (response) {
        console.log('index_location excel', response)

        if (response.body.meta != undefined && response.body.meta != null) {
          if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        // this.accesses = response.body.data;
        var vm = this;
        var temp = response.body.data;

        if(response.body.device){

            var dataAccess = temp.data

            for(var user in dataAccess){

              var validate = true

              for (var i = 0; i < vm.accessData.length; i++) {

                if(vm.accessData[i].user_rut == dataAccess[user]["employeeNoString"] && accessData[i].out_date == "" ){
                  validate = false
                  vm.accessData[i].out_date = dataAccess[user]["time"]
                }
              }

              if( validate == true){

                   vm.accessData.push({
                        user: dataAccess[user]["name"],
                        user_rut: dataAccess[user]["employeeNoString"],
                        in_date: dataAccess[user]["time"],
                        out_date: ""

                  })
              }

            }

            }else{

              // str.substring(0, str.length-1) + "-" + str.substring(str.length-1)
              for (var user in temp) {
                    var rut='';
                    var name=''
                    if(temp[user]["user_rut"]!=null){
                      rut = rut.substring(0, rut.length-1) + "-" + rut.substring(rut.length-1);
                    }

                  if(temp[user]["invited_client"]){
                      var rut = temp[user]["invited_client"]["rut"];
                      var name = temp[user]["invited_client"]["name"];
                    }else{
                      var rut = temp[user]["user_rut"];
                      var name = temp[user]["user_name"];
                    }


              accessData.push({
                user: name,
                user_rut: rut,
                // in_date:this.dateFormatText(this.$moment(temp[user]["date_in"]).format(" MM/DD/YYYY - h:mm a")),
                in_date: temp[ user ][ "date_in" ],

                // in_date:vm.$moment(temp[user]["date_in"]).format("dddd, MMMM Do YYYY, h:mm:ss a"),
                out_date: temp[ user ][ "date_out" ] != undefined ?
                  // this.dateFormatText(this.$moment(temp[user]["date_out"]).format(" MM/DD/YYYY - h:mm a")) : ""
                  temp[ user ][ "date_out" ] : ""

              })
            }

          }
        let excelData = accessData.map(access => {
          let accessInfo = {};
          accessInfo[ "Nombre" ] = access.user;
          accessInfo[ "Numero de documento" ] = access.user_rut.replace(/-/g, "");
          accessInfo[ "Hora de entrada" ] = this.dateFormatText(this.$moment(access.in_date).format(" MM/DD/YYYY - h:mm a"));
          accessInfo[ "Hora de salida" ] = access.out_date != '' ? this.dateFormatText(this.$moment(access.out_date).format(" MM/DD/YYYY - h:mm a")) : "";
          return accessInfo;
        })
        // Stylize the excel, column width
        let colStyle = [];
        Object.keys(excelData[ 0 ]).map(title => {
          colStyle.push({ wch: title.length + 1 });
        });
        excelData.map((accessInfo) => {
          Object.values(accessInfo).map((values, index) => {
            if (values.length + 1 > colStyle[ index ].wch) {
              colStyle[ index ].wch = values.length + 1;
            }
          })
        })

        let data = XLSX.utils.json_to_sheet(excelData);
        data[ "!cols" ] = colStyle;
        const workbook = XLSX.utils.book_new();
        let filename = "Reporte general personalizado"

        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);

      }, function (response) {
        if (response.body.data.message != null &&
          response.body.data.message != undefined &&
          response.body.data.message != '') {
          alert(response.body.data.message)
        } else {
          alert(response.body.data)
        }
      })
    },
  }, /* Closed methods */
  mounted(){
    // this.pagination.rowsPerPage=12;
    
    this.filterUsers(true);
    this.titlelocation=this.$route.params.namex;
    this.location_id = this.$route.params.id;
    this.location_name = this.$route.params.location_name;
    console.log('location_name', this.location_name)
  }
}
</script>
<style>
.theme--light.v-pagination .v-pagination__item{
  color: #5A6B8E !important;
}
.theme--light.v-pagination .v-pagination__item--active{
  color: #FFFFFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/access/Index_location.vue